import { Select } from 'antd';
import React from 'react';

const AssignSimpleTagDrawerContent = ({
  assignTagOptions = [],
  selectedTagIds,
  onSelectedTagIdsChange,
}) => (
  <>
    <div className="font-size-14 mb-8">Select tags to add</div>

    <div className="mb-16">
      <Select
        mode="multiple"
        style={{ width: '100%' }}
        placeholder="Select tags"
        value={selectedTagIds}
        onChange={onSelectedTagIdsChange}
        options={assignTagOptions}
      />
    </div>
  </>
);

export default AssignSimpleTagDrawerContent;
